import { GlobalToken } from 'antd/es/theme/interface'
import { CellValidator } from '../../../../helpers/cell-validators'
import { isDurstMachine } from '../../../../helpers/is-durst-machine'
import CalculationPosition from '../../../../types/api/calculation-position'

export const validateNumberOfVariantsForDigitColumn: CellValidator = (
    record: CalculationPosition,
    token: GlobalToken
) => {
    if (!isDurstMachine(record.machine)) {
        return null
    }

    const numberOfVariantsForDigit = record.numberOfVariantsForDigit

    if (
        numberOfVariantsForDigit === undefined ||
        numberOfVariantsForDigit === null ||
        numberOfVariantsForDigit === 0
    ) {
        return {
            message: 'Для станка Durst необходимо указать кол-во видов',
            bgColor: token.colorErrorBg,
            color: token.colorErrorText || token.colorError,
        }
    }

    return null
}
